import { NotifyHelper } from "../../../helpers/toast";
import { objDmKetQuaLienHeDefine } from "../../action-types/crm-category/IDmKetQuaLienHeActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const dmKetQuaLienHeActions = {
    ...generateActions(objDmKetQuaLienHeDefine, "DM_KET_QUA_LIEN_HE"),
    ...generateActionForKey(objDmKetQuaLienHeDefine, "DM_KET_QUA_LIEN_HE",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objDmKetQuaLienHeDefine, "DM_KET_QUA_LIEN_HE",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Lưu thành công")),
    ...generateActionForKey(objDmKetQuaLienHeDefine, "DM_KET_QUA_LIEN_HE",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objDmKetQuaLienHeDefine, "DM_KET_QUA_LIEN_HE",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Xóa thành công")),
    ...generateActionForKey(objDmKetQuaLienHeDefine, "DM_KET_QUA_LIEN_HE",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
